/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S1_BodyInputs */

const en_fc_tut_s1_body = /** @type {(inputs: Fc_Tut_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download FilmCraft for your system from our download guide, or run the web build in your browser. On first launch it loads a demo project, a good sandbox to click around in before you start your own.`)
};

/**
* | output |
* | --- |
* | "Download FilmCraft for your system from our download guide, or run the web build in your browser. On first launch it loads a demo project, a good sandbox to ..." |
*
* @param {Fc_Tut_S1_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s1_body = /** @type {((inputs?: Fc_Tut_S1_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S1_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s1_body(inputs)
});
export { fc_tut_s1_body as "fc.tut.s1.body" }